var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m1.229 2.708 3.319 2.178L7.857.326a.799.799 0 0 1 1.286 0l3.31 4.56 3.318-2.178a.798.798 0 0 1 1.096.215c.104.154.15.34.128.523l-1.3 10.867a.786.786 0 0 1-.784.687H2.089a.786.786 0 0 1-.785-.687L.005 3.446a.78.78 0 0 1 .693-.864.8.8 0 0 1 .53.126ZM8.5 10.332c.873 0 1.58-.697 1.58-1.556 0-.86-.707-1.556-1.58-1.556-.873 0-1.58.696-1.58 1.556 0 .86.707 1.556 1.58 1.556Z"
  })));
};
export default SvgCrown;